import { time } from "echarts"

const format = time => {
	let date = new Date(time)
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
//    
const format2 = time => {
	let date = new Date(time)
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
// 年月日
const formatDate2 = time => {
	let date = new Date(time)
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	return [year, month, day].map(formatNumber).join('-')
}
const formatYearTime = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	return [year, month].map(formatNumber).join('-')
}
// 当前日期时间 0000-00-00 00：00：00
const formatDate = time => {
	let date = new Date()
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
// 当前日期时间 0000-00-00 00：00：00
const formatDatetiem = time => {
	let date = new Date()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [hour, minute, second].map(formatNumber).join(':')
}
// 当前 00:00:00
const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}
//百分比（小数点后两位）
const percentage = (total, number) => {
	let num = ''
	if (total === '0') {
		num = '100'
	} else {
		num = (( Number(total) - Number(number)) / total) * 100
		if (num !== 100) {
			num = num.toFixed(2)
		}
	}
	return num
}
// 当前年
const currentYear = time => {
	let date = time; // 当前年
	const year = date.getFullYear()
	return String(year)
}
// 当前月
const currentMonth = time => {
	let date =new Date(time) ; // 当前月
	console.log(date)
	const month = date.getMonth()+1
	return String(month)
}
// 开始年 2022-1-1 00:00:00
const startYear = time => {
	let date = time; // 当前年
	const year = date.getFullYear()
	const month = '1'
	const day = '1'
	const hour = '00'
	const minute = '00'
	const second = '00'
	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
// 结束年 2022-12-31 23:59:59
const endYear = time => {
	let date = time; // 结束年
	const year = date.getFullYear()
	const month = '12'
	const day = '30'
	const hour = '23'
	const minute = '59'
	const second = '59'
	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
// 结束月 2020-10-31 23:59:59
const endMonth = time => {
	let date = time; // 
	const year = date.getFullYear()
	const month = date.getMonth()
	var monthEndDate = new Date(year, month + 1, 0);
	const endmonth = monthEndDate.getMonth() + 1
	const day = monthEndDate.getDate()
	const hour = '23'
	const minute = '59'
	const second = '59'
	return [year, endmonth, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
// 开始月  2020-10-1 00:00:00
const startMonth = time => {
	let date = time; // 
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = '1'
	const hour = '00'
	const minute = '00'
	const second = '00'
	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
const getBeforeTime = val =>{
	val = Number(val)
    //val是选择时间的单选框后传的天数
    let sjc = ''
    const nowDate = new Date().getTime()//获取当前时间戳
    if(val){
        sjc = 1000*3600*24*val
		console.log(1111)
    }else{
        //选全部时间
        return {str:'',end:''}
    }
    const str = format(nowDate-sjc)
    const end = format(nowDate)
    return {str,end}
}
// 维修状态
const RepairStatus = statusCode =>{
	switch (statusCode) {
		case 'pending':
			return '等待确认'
		case 'processing':
			return  "正在维修"
		case 'auditing':
			return "报价审核中"
		case 'unaudited':
			return "审核未通过"
		case 'confirmed':
			return "等待验收"
		case 'cost':
			return "等待关单"
		case 'success':
			return "关单结束"
		case 'canceled':
			return  "取消报修"
	}
}
/**
 * 小时数 转小时,分 [hour,min]
 * @param hours
 * @returns []
 */
 const formatHourNumToTime = (hours) => {
	let hour = String(hours).split('.')
	let min = 0
	if (hour.length > 1) {
		// hourInt = parseInt(hour[1])
		hour[1] = '0.' + hour[1]
		let hourNum = Number(hour[1])
		min = Math.round(hourNum * 60)
	}
	let result = [0, 0]
	if (hour[0] > 0) {
		result[0] = parseInt(hour[0])
	}
	if (min > 0) {
		result[1] = min
	}
	return result
}
/**
 * 小时数 转hour小时min分
 * @param hours
 * @returns
 */
 const formatHourNumToTimeStr = (hours) => {
	let hour = String(hours).split('.')
	let min = 0
	if (hour.length > 1) {
		// hourInt = parseInt(hour[1])
		hour[1] = '0.' + hour[1]
		let hourNum = Number(hour[1])
		min = Math.round(hourNum * 60)
	}

	let resultStr = ''
	if (hour[0] > 0) {
		let hourNum = Number(hour[0])
		if (hourNum >= 24) {
			let days = Math.floor(hourNum / 24)
			resultStr = days + '天'
			let hours = hourNum - days * 24
			resultStr += hours + '小时'
		} else {
			resultStr = hour[0] + '小时'
		}

	}
	if (min > 0) {
		resultStr += min + '分钟'
	}
	return resultStr
}
// 对象转数组对象
const fmObjToArr = (data)=> {
	let list = []
	for (let key in data) {
		list.push({
		label: key, // value字段
		value: data[key]  // label 字段  
	  })
	}
	return list
  }
/**
 * 删除数组中的某一个对象{}
 * @param arr {Array} 数组
 * @param obj {Object} 需要删除的对象
 * @returns {Array} 处理之后的数组
 */
 const arrRemoveObj = (arr, obj) => {
	let len = arr.length;
	for (let i = 0; i < len; i++) {
		if (arr[i] === obj) {
			if (i === 0) {
				arr.shift();
				return arr;
			} else if (i === len - 1) {
				arr.pop();
				return arr;
			} else {
				arr.splice(i, 1);
				return arr
			}
		}
	}
}
/**
 * 处理对象空值与null
 **/
 const removePropertyOfNull = (obj) => {
	for (var key in obj) {
		if (typeof(obj[key]) != "boolean" && typeof(obj[key]) != "number") {
			if (obj[key] == null || obj[key] == "") {
				delete obj[key]
			}
		}
	}
	return obj;
}
// 获取两个日期之间的每一天
const formatEveryDay = (start, end) => {
    let dateList = []; 
    var startTime = getDate(start);
    var endTime = getDate(end);

    while ((endTime.getTime() - startTime.getTime()) >= 0) {
        var year = startTime.getFullYear();
        var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
        var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
        dateList.push(year + "-" + month + "-" + day); 
        startTime.setDate(startTime.getDate() + 1);
    }
    return dateList;
}


const getDate =(datestr) => {
    var temp = datestr.split("-");
    var date = new Date(temp[0], temp[1] - 1, temp[2]);
    return date;
}

// 截取小数点后两位
const Intercept =(rateStr) => {

	if(rateStr.indexOf(".") != -1){
	   //获取小数点的位置
	   let num = 0;
	   num = rateStr.indexOf(".");
	   //获取小数点后面的数字 是否有两位 不足两位补足两位
	   let dianAfter = rateStr.substring(0,num+1);
	   let afterData = rateStr.replace(dianAfter, "");
	   if(afterData.length < 2){
		  afterData = afterData + "0" ;
	   }
	   return rateStr.substring(0,num) + "." + afterData.substring(0,2);
	}else{
	   /*if(rateStr == "1"){
		  return "100";
	   }else{
	   }*/
	   return rateStr;
	}
 }

export default {
	format2,
	format:format,
	formatDate: formatDate,
	formatDatetiem,
	percentage: percentage,
	currentYear: currentYear,
	currentMonth:currentMonth,
	startYear: startYear,
	endYear: endYear,
	startMonth: startMonth,
	endMonth: endMonth,
	RepairStatus: RepairStatus, // 维修状态
	formatHourNumToTime:formatHourNumToTime,
	formatDate2:formatDate2,
	formatHourNumToTimeStr,
	getBeforeTime,
	formatYearTime,
	fmObjToArr,
	arrRemoveObj,
	removePropertyOfNull,
	formatEveryDay,
	Intercept
}


// WEBPACK FOOTER //
// ./src/utils/util.js